var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheque(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H32C33.3807 15 34.5 16.1193 34.5 17.5V26.5C34.5 27.8807 33.3807 29 32 29H5C3.61929 29 2.5 27.8807 2.5 26.5V17.5C2.5 16.1193 3.61929 15 5 15Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15L6.46455 9.76121C7.03926 8.22863 8.73636 7.43959 10.2786 7.98793L30 15",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1023 21.0566L8.90911 21.7157H5.22729L5.42048 21.0566H9.1023ZM7.37502 25.4998L5.29548 22.9544L5.28411 22.4771H6.3182C6.58714 22.4771 6.81631 22.4392 7.0057 22.3635C7.1951 22.2858 7.33998 22.1703 7.44036 22.0169C7.54074 21.8616 7.59093 21.6665 7.59093 21.4316C7.59093 21.085 7.48676 20.8133 7.27843 20.6163C7.0701 20.4174 6.75002 20.318 6.3182 20.318H5.22729L5.42048 19.6816H6.3182C6.78033 19.6816 7.15911 19.7583 7.45457 19.9118C7.75192 20.0633 7.97161 20.2716 8.11366 20.5368C8.2576 20.8 8.32957 21.0983 8.32957 21.4316C8.32957 21.7328 8.26328 22.0102 8.1307 22.264C8.00002 22.5159 7.7898 22.7186 7.50002 22.872C7.21214 23.0254 6.83146 23.1021 6.35798 23.1021H6.34093L8.26139 25.4544V25.4998H7.37502ZM9.1023 19.6816L8.90911 20.3407L6.01139 20.318L6.20457 19.6816H9.1023Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5H26M12 21.5H23M12 26H19.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29L18 32L21 31L36.5 15.7109L34.5 13.7109L19 29Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4143 15.0391L37.2661 14.1874C37.5767 13.8767 37.5767 13.3731 37.2661 13.0625V13.0625C36.9554 12.7518 36.4518 12.7518 36.1412 13.0625L35.2894 13.9142",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28.5L21.5 30.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheque);
export default __webpack_public_path__ + "static/media/Cheque.cb1d9777f7415657a54f0b5403aa95df.svg";
export { ForwardRef as ReactComponent };